define(function () {
    const config = require('Cloud/config');
    const IS_MOBILE = config.get('MOBILE_BROWSER');
    const { showAuth } = require('reactApp/utils/auth');

    return function () {
        return {
            async show(params) {
                params = params || {};

                const fromStartMobile = (params.fromStart && IS_MOBILE) || false;

                if (!fromStartMobile && window.__PH && window.__PH.authForm) {
                    params.closable = params.closable || false;

                    if (params.formType === 'restore') {
                        params.focus = 'password';
                    }

                    showAuth(params);
                } else if (IS_MOBILE) {
                    window.location.href = `https://touch.mail.ru/login?page=${encodeURIComponent(window.location.href)}`;
                } else {
                    // eslint-disable-next-line no-console
                    console.error('LOGIN');
                }
            },

            hide() {
                window.__PH.authForm.hide();
            },

            close() {
                this.hide();
            },
        };
    };
});
